import React from 'react';
import { Element } from 'slate';
import {
  EditableProps,
  RenderElementProps,
  RenderLeafProps,
} from 'slate-react/dist/components/editable';
import { AulaEditorContext, AulaEditorInstance } from '../types';

export type BlockMenuItemRendererProps = {
  element: Element;
  text?: string;
  onClose?: () => void;
  openFileDialog?: () => void;
  children?: any;
  attributes?: any;
};

export type BlockMenuItemRenderer = (
  props: BlockMenuItemRendererProps,
) => JSX.Element;

export type BlockMenuNode =
  | {
      [key: string]: BlockMenuNode | BlockMenuItemRenderer;
    }
  | BlockMenuItemRenderer;

export type BlockMenuRoot = {
  [key: string]: BlockMenuNode | BlockMenuItemRenderer;
};

/**
 * AulaBlockMenuProps
 *
 * props used to compose the block menu
 */
export type AulaBlockMenuProps = {
  blockMenu?: BlockMenuRoot;
  renderSubMenuItem?: BlockMenuItemRenderer;
};

/**
 * AulaPluginProps
 *
 * The type that every plugin produces and ingests
 */
export type AulaPluginProps = EditableProps & AulaBlockMenuProps;

export type AulaPlugin = (
  props: AulaPluginProps,
  editor: AulaEditorInstance,
  context?: AulaEditorContext,
) => AulaPluginProps;

// default render element
export const defaultRenderElement = ({
  children,
  attributes,
}: RenderElementProps) => <p {...attributes}>{children}</p>;

export const defaultRenderLeaf = ({
  children,
  attributes,
}: RenderLeafProps) => <span {...attributes}>{children}</span>;

export const composePlugins = (
  plugins: AulaPlugin[],
  editor: AulaEditorInstance,
  context: AulaEditorContext,
): EditableProps => {
  let res: AulaPluginProps = {
    renderElement: defaultRenderElement,
    renderLeaf: defaultRenderLeaf,
  };
  for (const plugin of plugins) {
    res = plugin(res, editor, context);
  }

  /**
   * all non standard editable props are left out of the final output
   * so that we don't get prop errors
   */
  const {
    renderSubMenuItem: _renderSubMenuItem,
    blockMenu: _blockMenu,
    ...editableProps
  } = res;

  return editableProps;
};
